import { useEffect, useState } from 'react';
import { getAlgoliaIndexNameCompanies } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';

const useAlgoliaCompanies = companyIds => {
    const { searchClient } = useAlgoliaClient();
    const [companies, setCompanies] = useState();

    useEffect(() => {
        if (!searchClient || !companyIds) {
            return;
        }

        (async () => {
            const filterString = companyIds.map(id => `objectID:company-${id}`).join(' OR ');
            const { results } = await searchClient.search([
                {
                    indexName: getAlgoliaIndexNameCompanies(),
                    params: { filters: filterString || 'objectID:NOT-A-COMPANY' },
                },
            ]);

            if (results.length > 0) {
                setCompanies(results[0].hits);
            }
        })();
    }, [searchClient, companyIds]);

    return { companies };
};

export default useAlgoliaCompanies;
